import _ from 'lodash'
import store from '@/store'

import ConfirmationModal from '@/components/modal/ConfirmationModal'
import InformationModal from '@/components/modal/InformationModal'

const SET_COMPONENT = 'setModalComponent'

const modalStoreModule = {
  state: {
    component: undefined,
    props: undefined,
    close: undefined,
    dismiss: undefined
  },
  actions: {
    [SET_COMPONENT] (context, payload) {
      let allowed = !context.state.component

      const promise = new Promise((resolve, reject) => {
        if (!allowed) {
          reject(new Error())
        } else {
          context.commit(SET_COMPONENT, Object.assign(payload, {
            close: (result) => {
              context.commit(SET_COMPONENT)
              resolve(result)
            },
            dismiss: (error) => {
              context.commit(SET_COMPONENT)
              reject(error)
            }
          }))
        }
      })
      return promise
    }
  },
  mutations: {
    [SET_COMPONENT] (state, payload) {
      if (!payload) {
        state.component = undefined
        state.props = undefined
        state.close = undefined
        state.dismiss = undefined
        document.body.className = ''
      } else {
        Object.assign(state, payload)
        document.body.className = 'po-modal-open'
      }
    }
  }
}

store.registerModule('modal', modalStoreModule)

export const showModal = (component, props) => {
  return store.dispatch(SET_COMPONENT, { component, props })
}

export const showConfirmation = (options, confirmCallback) => {
  const safeOptions = _.isString(options) ? { messageKey: options } : options
  const props = Object.assign({
    confirm: confirmCallback,
    focusConfirm: true
  }, safeOptions)
  return store.dispatch(SET_COMPONENT, { component: ConfirmationModal, props })
    .catch(e => {})
}

export const showInformation = (options) => {
  return store.dispatch(SET_COMPONENT, { component: InformationModal, props: options })
    .catch(e => {})
}
